import request from "@/services/request"

const api = {
    wxorder: "/wxPay/make_order",
    query: "/wxPay/query"
}


/**
 * 充值下单
 * @param {*} param0
 */
export function getWxorder(params) {
    return request({
        url: api.wxorder,
        method: "get",
        params
    })
}


/**
 * 查询支付接口
 */
export function getQuery(params) {
    return request({
        url: api.query,
        method: "get",
        params
    })
}